import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import de from '../translations/de.json';
import en from '../translations/en.json';

i18n.use(LanguageDetector).use(initReactI18next).init({
  debug: true,

  resources: {
    en: en,
    de: de
  },

  lng: 'en',
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false,
  },

  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
  },

  saveMissing: true
});

export default i18n;